export default "__VITE_ASSET__$sXRraNF__"